import { AddCustomersComponent } from './../components/registry/customers/add-customers/add-customers.component';
import { AddProductsComponent } from './../components/registry/products/add-products/add-products.component';
import { GlobalService } from './../services/global.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { DirectivesModule } from './../directives/directives.module';
import { NgModule, ModuleWithProviders, LOCALE_ID } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import i18n_it from "../../assets/i18n/i18n_it.json";
import i18n_en from "../../assets/i18n/i18n_en.json";
import i18n_fr from "../../assets/i18n/i18n_fr.json";
import { EqpDashboardModule } from '@eqproject/eqp-dashboard';
import { DatePickerModule } from './datePicker.module';
import { ProductsLimitationsComponent } from '../components/licenses/products-limitations/products-limitations.component';
import { ValidatorsModule } from "ngx-validators";
import { ViewNotificationComponent } from '../components/notifications/view-notification/view-notification/view-notification.component';
import { DxAccordionModule, DxPopupModule, DxCheckBoxModule, DxHtmlEditorModule, DxDataGridModule, DxLookupModule, DxButtonModule, DxSelectBoxModule, DxValidatorModule, DxTextBoxModule, DxDateBoxModule, DxNumberBoxModule, DxCircularGaugeModule, DxLinearGaugeModule, DxBarGaugeModule, DxDropDownBoxModule, DxPopoverModule, DxTemplateModule, DxContextMenuModule } from 'devextreme-angular';
import { DxoSeriesTemplateModule } from 'devextreme-angular/ui/nested';
import { provideEnvironmentNgxCurrency,NgxCurrencyDirective , NgxCurrencyInputMode } from 'ngx-currency';
import { NamirialpayPaymentsComponent } from '../components/document/payments/namirialpay/namirialpay-payments.component';
import dxNumberBox from 'devextreme/ui/number_box';
import { EnterprisesSearchComponent } from '../components/registry/customers/enterprises-search/enterprises-search.component';
import { AddStableOrganisationComponent } from '../components/registry/customers/add-stable-organisation/add-stable-organisation.component';
import { FpDxLookupComponent } from '../components/core/fp-dx-lookup/fp-dx-lookup.component';
import { FpDxDataGridComponent } from '../components/core/fp-dx-datagrid/fp-dx-datagrid.component';
import { CdvEventComponent } from '../components/document/cdv/cdv-event/cdv-event.component';

registerLocaleData(localeIT, 'it-IT');


@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonModule,    
    EqpDashboardModule,
    NgSelectModule,
    DirectivesModule,
    DatePickerModule,
    ValidatorsModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxValidatorModule,
    DxDateBoxModule,
    NgxCurrencyDirective,   
    DxButtonModule,
    DxDataGridModule,
    DxLookupModule,    
    DxLookupModule,
    DxHtmlEditorModule,
    DxCheckBoxModule,
    DxPopupModule,
    DxCircularGaugeModule,   
    DxBarGaugeModule, 
    DxAccordionModule,
    DxNumberBoxModule,
    DxDropDownBoxModule,
    DxPopoverModule,
    DxTemplateModule,
    DxContextMenuModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    CommonModule,    
    EqpDashboardModule,
    NgSelectModule,
    DirectivesModule,
    TranslateModule,
    DatePickerModule,
    ProductsLimitationsComponent,    
    ViewNotificationComponent,
    ValidatorsModule,
    DxButtonModule,
    DxTextBoxModule,
    DxLookupModule,
    DxoSeriesTemplateModule,
    DxDateBoxModule ,
    DxDataGridModule,
    DxSelectBoxModule,
    DxHtmlEditorModule,
    DxPopupModule,    
    DxCircularGaugeModule,
    DxBarGaugeModule,
    DxAccordionModule,    
    DxPopupModule,
    DxAccordionModule,   
    DxPopoverModule,
    DxTemplateModule,
    DxContextMenuModule,
    DxNumberBoxModule, 
    DxDropDownBoxModule,
    NgxCurrencyDirective,
    DxCheckBoxModule,
    NamirialpayPaymentsComponent,
    CdvEventComponent,
    FpDxLookupComponent,
    FpDxDataGridComponent

  ],
  declarations: [
    AddProductsComponent,
    AddCustomersComponent,
    ProductsLimitationsComponent,
    ViewNotificationComponent,
    NamirialpayPaymentsComponent,
    CdvEventComponent,
    EnterprisesSearchComponent,
    AddStableOrganisationComponent,
    FpDxLookupComponent,
    FpDxDataGridComponent

  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: GlobalService.getSelectedLanguage() + "-" + GlobalService.getSelectedLanguage().toUpperCase() },
    { provide: LOCALE_ID, useValue: GlobalService.getSelectedLanguage() + "-" + GlobalService.getSelectedLanguage().toUpperCase() },
    provideEnvironmentNgxCurrency({
      align: "right",
      allowNegative: true,
      allowZero: true,
      decimal: ",",
      precision: 5,
      prefix: "",
      suffix: "",
      thousands: "",
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Natural
    }),
  ],
})
export class SharedModule {

  constructor(private adapter: DateAdapter<any>, private translate: TranslateService) {

    /**
     * Inizializzo la lingua
     */
    if (GlobalService.getSelectedLanguage() == "it") {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_it, true);
    } else if (GlobalService.getSelectedLanguage() == "fr") {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_fr, true);
    } else {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_en, true);
    }

    this.translate.use(GlobalService.getSelectedLanguage());

    this.setDateAdapterLocale("it-IT");
    registerLocaleData(localeIT);
  }


  setDateAdapterLocale(localeString: string): void {
    this.adapter.setLocale(localeString);
    this.adapter.getFirstDayOfWeek = () => { return 1; }
  }

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    }
  }
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export class COMPONENT_MAPPER {
  public static pool: { [key: string]: any } = {};
  static get(key: string) {
    let entity = COMPONENT_MAPPER.pool[key];
    if (!entity) {
      throw new Error(
        `No entity mapped for '${key}'. Please register Entity with component mapper service on your start up`
      );
    }
    return entity;
  }
}
